import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { layouts } from 'seal-ui-components';
import styled from 'styled-components';
import Footer from '@Components/UI/Footer';
import NotificationMessage from '@Components/UI/NotificationMessage';
import TopNav from '@Components/TopNav';
import ContentRoute from '@Routes/ContentRoute';
import SubmitForAnalysis from '@Components/SubmitForAnalysis';
import SettingsFooter from '@Pages/Settings/components/SettingsFooter';
import HitsProcess from '@Components/BackgroundProcesses/HitsProcess';
import LabelsProcess from '@Components/BackgroundProcesses/LabelsProcess';
import CheckDocumentStateProcess from '@Components/BackgroundProcesses/CheckDocumentStateProcess';
import { MarkupDetails } from '@Pages/Markup/components/MarkupDetails';
import ReleaseNotesDialog from './components/ReleaseNotes';

const BaseLayoutBody = styled(layouts.VerticalBox)`
    flex: 1;
    flex-basis: 100%;
`;

const BaseLayout = () => {
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    const showReleaseNotes = useSelector(state => state.auth.showReleaseNotes);

    const [dialogAnimationStartDimension, setDialogAnimationStartDimension] = useState(undefined);

    const history = useHistory();
    const location = useLocation();
    const showSubmitFooter =
        isAuthenticated &&
        location.pathname.substring(1) !== 'settings' &&
        location.pathname.substring(1) !== 'loading';

    const { overflowY } = useSelector(state => state.base);
    const overflowX = overflowY === 'visible' ? 'visible' : 'hidden';
    const currentPage = location.pathname.substring(1);

    return (
        <>
            <NotificationMessage />
            <HitsProcess />
            <LabelsProcess />
            <CheckDocumentStateProcess currentPage={currentPage} />
            <MarkupDetails />

            <ReleaseNotesDialog
                isVisible={showReleaseNotes}
                dialogAnimationStartDimension={dialogAnimationStartDimension}
            />

            <TopNav />
            <BaseLayoutBody style={{ overflowY: overflowY, overflowX: overflowX }}>
                <ContentRoute />
            </BaseLayoutBody>

            {showSubmitFooter ? (
                <Footer boxshadow bgcolor>
                    <SubmitForAnalysis history={history} />
                </Footer>
            ) : (
                <Footer>
                    <SettingsFooter
                        className="settings-footer-container"
                        setDialogAnimationStartDimension={setDialogAnimationStartDimension}
                    />
                </Footer>
            )}
        </>
    );
};

export default BaseLayout;
